module.exports = __webpack_public_path__ + "img/4bd7e0fade31d8887793dc4f32866ec6.png";